export abstract class ComponentInterfaceBaseClass {
    // implement static methods based on needs such as...
    // static initWithSanity(key: string, feed: any): Object;
    abstract toJsx(runtimeProps?: Object): JSX.Element | null;
    abstract toProps(runtimeProps?: Object): Object;
}